<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import AssetTag from '@/components/asset/AssetTag.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import IconTextButton from '@/components/ui/button/IconTextButton.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import AppDialog from '@/components/app/AppDialog.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import Input from '@/components/ui/form/FormInput.vue';
import AppSelect from '@/components/app/AppSelect.vue';
import AssetPlayer from './AssetPlayer.vue';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
export default {
    components: {
        AssetTag,
        TextButton,
        IconTextButton,
        TextButtonBlock,
        AppDialog,
        CustomSwitch,
        Input,
        AppSelect,
        AssetPlayer,
        AppSnackbar,
    },
    data() {
        return {
            showBtn: false,
            type: null,
            idx: 0,
            playVal: false,
            encodeList: [],
            thumbnailList: [],
            delConfirm: false,
            selIdx: 0,
            customSize: false,
            customSizeEndIdx: 0,
            temp: null,
            cImg: null,
            assetInfo: {},
            encodeInfo: {},
            smil_url: null,
            smil_player_url: null,
            tagVal: null,
            chips: [],
            datas: [],
            items: [],
            name: null,
            explanation: null,
            initGroups: [],
            poster: null,
            thumnail_c: null,
            tags: [],
            timeout: null,
            stateCheck: false,
            checkStatusVal: null,
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            snackbarErrorText: '',
        }
    },
    methods: {
        ...mapActions('asset', ['deleteTag', 'fetchDetailInfo', 'uploadTask', 'deleteTask', 'updateDistribution', 'fetchGroupList', 'groupingSingle', 'updateDatas', 'addTag']),
        playVideo(){
            // console.log("open")
            this.playVal = true;
        },
        closeVideo(){
            // console.log("close")
            this.playVal = false;
        },
        copyBtn(val){
            // console.log("카피 텍스트 : ", val)
            this.$copyText(val)
                .then(() => {

                })
                .catch(() => {
                    alert('Failed to copy text.');
                });
        },
        // initPlay(){
        //     console.log("로드 플레이 (modify) setting")
        //     const iframe = this.$refs.iframe;
        //     iframe.onload = () => {
        //         console.log("iframe 로드");
        //         const video = iframe.contentWindow.document.querySelector('video');
        //         if (!video) return;
        //     };
            

        // },
        // loadPlay(){
        //     console.log("로드 플레이 (modify)")
        //     const iframe = this.$refs.iframe;
        //     const video = iframe.contentWindow.document.querySelector('video');
        //     if (!video) return;

        //     video.autoplay = true;
        //     // video.play();
        //     video.addEventListener('loadedmetadata', () => {
        //         video.play();
        //     });                

        //     // const iframe = this.$refs.iframe;
        //     // if (!iframe || !iframe.contentWindow || !iframe.contentWindow.document) return;
        //     // iframe.contentWindow.postMessage({ message: 'playVideo' }, '*');

        //     // window.addEventListener('message', event => {
        //     //     if (event.data === 'playVideo') {
        //     //         console.log("event.data => ", event.data)
        //     //         const video = iframe.contentWindow.document.querySelector('video');
        //     //         if (!video) return;
        //     //         if (video) {
        //     //             video.autoplay = true;
        //     //             video.play();
        //     //         } else {
        //     //             console.error('영상을 찾을 수 없습니다.');
        //     //         }
        //     //     }
        //     // });
        // },
        showInfo(item, index){
            if (this.encodeInfo) {
                // this.type = this.encodeInfo.map(e => e.find(e => e.resolution === item))[0];
                this.type = this.encodeInfo.find(e => e.resolution === item) || [];
                // console.log("this.type => ", this.type)
                this.idx = index;
            }
        },
        showOriginInfo(){
            this.type = null;
        },
        changeThumbnail(data){
            this.cImg = data;
        },
        uploadThumbnail(event){
           const file = event.target.files[0];
           if(!file) return;

           const reader = new FileReader();
           reader.onload = async (e) => {
                const fileContent = e.target.result;
                const formData = new FormData();
                formData.append('file', file);
                formData.append('asset_id', this.detailId);
                formData.append('aid', this.assetInfo.aid);
                const res = await this.uploadTask(formData);
                if(res === 1){
                    await this.fetchDetailInfo();
                }
            } 
            reader.readAsText(file);

            setTimeout(() => {
                this.snackbar = true;
                this.snackbarText = '썸네일 추가를 성공했습니다.';
                this.snackbarError = false;
                setTimeout(() => {
                this.$router.go();
                }, this.timeout);
            }, 1000);


        },
        async deleteThumbnail(index){
            const url = this.thumbnailList.pop().thumbnail360;

            let check;
            if(url === this.cImg){ 
                check = false;
            }
            const params = {
                url: url,
                check: check,
                asset_id: this.detailId
            }

            this.thumbnailList.splice(index, 1);

            const res = await this.deleteTask(params);
            this.closeDialog('delConfirm');
            if(res === 1){
                this.closeDialog('delConfirm');
                setTimeout(() => {
                    this.snackbar = true;
                    this.snackbarText = '썸네일 파일 삭제를 성공했습니다.';
                    this.snackbarError = false;
                    setTimeout(() => {
                        this.$router.go();
                    }, this.timeout);
                }, 1000);
            }
        },
        showdelConfirmation(index){
            this.selIdx = index;
            this.delConfirm = true;
        },
        async closeDialog(dialogName){
            this[dialogName] = false;
           await this.fetchDetailInfo();
        },
        async toggleSwitch(){
            const newState = !this.switchState;
            // const folder = this.checkStatusVal === 'uploaded' ? 'upload' : 'encoded';
            // let smil_url_upload;
            // if(this.checkStatusVal === 'upload'){
            //     smil_url_upload = this.assetInfo.Hlsurl;
            // }
            // else {
            //     smil_url_upload = this.smil_url;
            // }
            const params = {
                id: this.detailId,
                aid: this.assetInfo.aid,
                type: this.switchState ? 'unpub' : 'pub',
                smil_url: this.smil_url,
                newState: newState,
                folder: this.checkStatusVal,
            }
           this.$store.commit('asset/setSwitchState', newState);
           const res = await this.updateDistribution(params);
            if(res !== 1){
                this.$store.commit('asset/setSwitchState', !newState);
            }
        },

        goAsset(){
            this.$router.push('/asset');
        },

        validateThumbnails(){
            const validationPromises = this.thumbnailList.map(e => 
                this.checkThumbnail(e.thumbnail360)
            );

            Promise.all(validationPromises)
                .then(e => {
                    this.thumbnailList = e.filter(e => e !== null);
                })
                .catch(error => {
                    console.error('error => ', error);
                });
        },

        checkThumbnail(url){
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve({ thumbnail360: url });
                img.onerror = () => resolve(null);
                img.src = url;
            });
        },

        async setAssetInfo(){

            this.assetInfo = this.info[0];
            //console.log("원본 => ", this.assetInfo)

            this.checkStatusVal = this.assetInfo?.status;

            // const check = this.assetInfo.status;
            this.datas = this.assetInfo.groups.map(e => e.group_name);
            this.initGroups = this.datas;
            this.items = Object.values(this.groupList).map(e => e.group_name);
            this.name =  this.assetInfo.name;
            this.explanation = this.assetInfo.explanation;
            // this.thumnail_c = this.assetInfo.thumnail_c;
            this.poster = this.assetInfo.image;
            this.tags = this.assetInfo.tag;

            // console.log("데이터확인 modifyForm =>",this.assetInfo)

            // 원본 or 인코딩 예외처리
            //console.log("인코딩 파일 확인")
            this.encodeInfo  = this.assetInfo.encodingInfo.map(e => e);
            if(this.assetInfo.thumnail_element_C === null){
                this.customSize = false;
                this.customSizeEndIdx = 0;
            }
            else {
                this.customSize = true;
                this.customSizeEndIdx = 1;
            }
            // 썸네일 n개
            const url = this.assetInfo.imageUrl;
            // console.log("url => ", url)
            this.thumbnailList = JSON.parse(this.assetInfo?.image_360 || '[]');
            // console.log("image_360 => ", this.thumbnailList)
            if (this.thumbnailList && this.thumbnailList.length > 0) {
                const newList = this.thumbnailList.map(e => ({ thumbnail360: url + e }));
                this.thumbnailList = newList;
                if(this.customSize){
                    if (this.assetInfo && this.assetInfo.thumnail_element_C) {
                        const tmp = JSON.parse(this.assetInfo.thumnail_element_C)[0].url;
                        // const tmp =  Object.values(this.assetInfo.thumnail_element_C).find(e => e).url;
                        //console.log("확ㅇ니확인 => ", tmp)
                        if(tmp){
                            const newImg = { thumbnail360: tmp };
                            this.thumbnailList = [...this.thumbnailList, newImg];
                        }
                    }   
                }
                this.validateThumbnails();
            }
            
            //console.log("썸네일 N => ", this.thumbnailList)

            // 대표 썸네일
            this.cImg = this.assetInfo.image;

            // url 설정
            this.smil_url = this.assetInfo.smil_url;
            this.smil_player_url = this.assetInfo.playUrl;
            // console.log("url 설정 smil_url =>", this.smil_url);
            // console.log("url 설정 smil_player_url =>", this.smil_player_url);

            // 해상도 리스트
            this.encodeList = this.encodeInfo.map(e => e.resolution).filter(e => e !== undefined && e  !== null && e != "");

            // this.stateCheck = this.assetInfo?.encoding_status === 'Published' && this.assetInfo?.status !== 'processing' && this.assetInfo?.upload_v_codec === 'h264';
            const a = this.assetInfo?.encoding_status === 'Published' && this.assetInfo?.status !== 'processing';
            const b = this.assetInfo?.upload_v_codec === 'h264' && this.assetInfo?.status.includes('uploaded');
            const c = this.assetInfo?.upload_v_codec !== 'h264' && this.assetInfo?.status.includes('encoded');
            const d = this.assetInfo?.upload_v_codec === 'h264' && this.assetInfo?.status.includes('encoded');

            this.stateCheck = false;
            if(a){
                if(b){
                    this.stateCheck = true;
                }
                if(c){
                    this.stateCheck = true;
                }
                if(d){
                    this.stateCheck = true;
                }
            } else {
                this.stateCheck = false;
            }


            // pub/unpub state
            if(this.assetInfo.encoding_status === "Unpublished"){
                this.temp = false;
            }
            else {
                this.temp = true;
            }
            //console.log("pub/unpub => ", this.temp)
            this.$store.commit('asset/setSwitchState', this.temp);

        },
        handleEnter(val){
            this.tagVal = val;
            if (this.tagVal.trim() !== '') {
                this.chips.push(this.tagVal.trim());
                this.$nextTick(() => {
                    this.tagVal = '';
                });
            }
        },
        async onClose(val) {
            if(typeof val === 'object'){
                const params = {
                    asset_id: this.detailId,
                    tag_id: val.id
                }
                const res = this.deleteTag(params);
                if(res === 1){
                    await this.fetchDetailInfo();
                }
            }
            else if(typeof val === 'string') {
                const index = this.chips.indexOf(val);
                if (index !== -1) {
                    this.chips.splice(index, 1);
                }
            }

        },
        selGrouping(val){
            //console.log("전달?", val)
            this.datas = val;
        },
        async loadData(){
            await this.fetchDetailInfo();
            await this.fetchGroupList();
            this.setAssetInfo();
        },
        isObject(value) {
            return typeof value === 'object' && value !== null && !Array.isArray(value);
        },
        async updateInfo(){
            let result = [];
            // 기본 정보 수정
            const params = {
                asset_id: this.detailId,
                name:  this.name,
                explanation: this.explanation,
                poster: this.currentImage
            }
            const res = await this.updateDatas(params);
            if(res === 1){
                result.push(true);
                //console.log("통과 1")
           }

            // 그룹 정보 수정
            const diff = !this.isEqualCheck(this.datas, this.initGroups);
            if (diff) {
                // 다름
                const tmp = Object.values(this.datas);
                const groupIds = tmp.map(data => {
                    const obj = this.groupList.find(e => e.group_name === data);
                    return obj ? obj.id : null;
                });
                // console.log("groupIds => ", groupIds)

                const params = {
                    asset_id: this.detailId,
                    groupIds: groupIds
                };
                const res = await this.groupingSingle(params);
                if(res === 1){
                    result.push(true);
                    //console.log("통과 2")
                    // v-snackbar
                }
            } 
            else {
                // 같음
            }
           // 태그 정보 수정
            if(this.chips.length > 0){
                const params = {
                    asset_id: this.detailId,
                    tag_names: this.chips
                };
                const res = await this.addTag(params);
                if(res === 1){
                    result.push(true);
                    //console.log("통과 3")
                }
            }

            const isAllTrue = result.every(e => e === true);
            if(isAllTrue){
                //console.log("통과 4")
                //console.log("isAllTrue 1=> ",isAllTrue)
                this.timeout = 2000;
                
                setTimeout(() => {
                    this.snackbar = true;
                    this.snackbarText = '정보 수정에 성공했습니다.';
                    this.snackbarError = false;
                    setTimeout(() => {
                    this.$router.go();
                    }, this.timeout);
                }, 1000);
            }
            else {
                //console.log("isAllTrue 2=> ",isAllTrue)
                // this.timeout = 2000;
                // setTimeout(() => {
                //     this.showSnackbarError = true;
                //     this.snackbarErrorText = '정보를 수정하는데 실패했습니다.';
                //     setTimeout(() => {
                //     this.$router.go();
                //     }, this.timeout);
                // }, 1000);
            }
        },
        isEqualCheck(obj01, obj02){
            if (typeof obj01 !== 'object' || typeof obj02 !== 'object') {
                return false;
            }

   
            const keys1 = Object.keys(obj01);
            const keys2 = Object.keys(obj02);

   
            if (keys1.length !== keys2.length) {
                return false;
            }

            for (let key of keys1) {
                if (!this.isEqualCheck(obj01[key], obj02[key])) {
                    return false;
                }
            }
            return true;
        },
        handleInput(val, type){
            // console.log("확인 => ", val, type)

            if(type === 'name'){
                this.name = val;
            }
            else if(type === 'explanation'){
                this.explanation = val;
            }
        },
        goBack() {
            window.history.back();
        },
    },
    watch: {
        cImg: {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.currentImage = newValue;
                }
            },
            immediate: true,
            deep: true
        },
    },
    computed: {
        ...mapGetters('asset', ['groupList']),
        ...mapState('asset', ['detailInfo', 'switchState', 'detailId', 'groupList', 'loading']),
        info(){
            if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                return this.detailInfo.map(e => e);
            }
        },
        // checkStatusVal(){
        //     if(this.detailInfo !== null && typeof this.detailInfo !== 'undefined'){
        //         if(this.assetInfo.status === 'uploaded'){
        //             return 'upload';
        //         }
        //         else if(this.assetInfo.status.match(/^encoded\s/)){
        //             return 'encoded';
        //         }
        //         else if(this.assetInfo.status === 'processing'){
        //             return 'processing';
        //         }
        //     }
        //     return null;
        // },
        size(){
            if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                if(this.type === null){
                    return this.assetInfo.upload_size;
                }
                else {
                    const data = this.type.size;
                    return data;
                }
            }
        },
        metaInfo(){
            if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                if(this.type === null){
                    const tempInfo = {
                            resolution: this.assetInfo.upload_resolution,
                            codec: this.assetInfo.upload_v_codec,
                            bitrate: this.assetInfo.upload_bitrate,
                            size: this.assetInfo.upload_size
                    };
                
                    return tempInfo;
                }
                else {
                    return this.type;
                }
            }
        },
        currentImage: {
           get(){
                if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                    //console.log("현재이미지 => ", this.cImg)
                    if (this.cImg && this.cImg.trim() !== "") {
                        return this.cImg;
                    } else {
                        return "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png";
                    }
                }
           },
           set(newVal){
                this.cImg = newVal;
           }
        },
        getShowCheck(){
            return (index) => {
                if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                    if(this.customSize && this.customSizeEndIdx === 1 && index === this.thumbnailList.length -1){
                    return true;
                    }
                    return false;
                }
            }
        },
        isDisabled(){
            if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined' && this.assetInfo) {
                if(this.customSizeEndIdx === 0 && !this.customSize){
                    return false;
                }
                return true;
            }
        },
        isShow(){
            if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined' && this.assetInfo) {
                if(this.customSizeEndIdx === 0 && !this.customSize){
                    return true;
                }
                return false;
            }
        }

    },
    mounted(){
        this.loadData()
    },
};
</script>
<template>
    <!--container-->
    <div class="Background">

        <!--title-->
        <h2 class="Title">
            {{ info.name }}
        </h2>

        <v-row>
            <v-col class="modify_left_wraper" style="position: absolute;">
                <div style="position: relative; 
                background-color: black; 
                width: 100%;
                height: 281.25px;
                display: flex; 
                justify-content: center; 
                align-items: center; 
                overflow: hidden;
                border-radius: 12px;">
                    <v-img :src="currentImage" style="height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;" :contain="true">
                        <div class="overlay">
                            <v-icon v-if="stateCheck" style="font-size: 60px;" @click="playVideo">mdi-play-circle</v-icon>
                        </div>
                    </v-img>
                    <AssetPlayer :compType="true" v-if="playVal" :poster="poster" :playVal="playVal" :playUrl="smil_player_url" :playerName="name"  :closeVideo="closeVideo" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" />
                </div>
                <!-- <v-card>
                    <v-toolbar color="black" dark v-if="playVal">
                        <span>{{ name }}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeVideo">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <div class="video-container" ref="videoContainer" style="position: relative;">
                        <v-img :src="currentImage" @click="playVideo"></v-img>
                        <div v-if="playVal" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; background-color: rgba(0, 0, 0, 0.7);">
                            <iframe ref="iframe" scrolling="no" :src="smil_player_url" frameborder="0" allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
                        </div>
                    </div>
                </v-card> -->

                

                <!-- <div class="video-container"  ref="videoContainer" @click="playVideo">
                    <v-img :src="currentImage" ></v-img>
                    <iframe v-if="playVal" ref="iframe" scrolling="no" :src="smil_player_url" frameborder="0" allowfullscreen  @load="initPlay" @playing="loadPlay"></iframe>
                </div> -->
                <div class="thumnail">
                    <h3 class="cont_title">
                    섬네일
                        <!-- <TextButton :buttonText="'섬네일 편집'" outlined :small="true" class="ml-2"  :buttonClick="() => closeVideo()"/> -->
                            <TextButton :buttonText="'섬네일 편집'" outlined :small="true" class="ml-2"  @click="closeVideo"/>
                    </h3>

                    <div class="thumnail_box">
                        <v-row>
                            <v-col v-show="isShow" class="pr-2" style="width: 66px;">
                                <!-- <v-card :disabled="isDisabled"  class="thumnail_upload" link outlined @click="$refs.fileInput.click();"> -->
                                <v-card class="thumnail_upload" link outlined @click="$refs.fileInput.click();">
                                    <input type="file" ref="fileInput" style="display: none" @change="uploadThumbnail">
                                    <v-icon class="mdi mdi-image-plus-outline mt-2" small color="#bbb"/><br>
                                    <span>섬네일 업로드</span>
                                </v-card>

                            </v-col>
                            
                            <v-col  v-for="(item, index) in thumbnailList" :key="index" style="width: 66px;" class="pr-2">
                                <v-card link outlined @click="changeThumbnail(item.thumbnail360)">
                                    <v-img :src="item.thumbnail360" height="46px"/>
                                    <span v-show="getShowCheck(index)" @click="showdelConfirmation(index)" class="delete-icon" style="margin-top: -4px;"><v-btn elevation="0" x-small icon style="position: absolute;top: 0;right: 0;"><v-icon>mdi-close-circle</v-icon></v-btn></span>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <div class="mt-5">
                    <h3 class="table_title">
                        INFO
                    </h3>
                    <v-simple-table>
                        <template>
                            <thead>
                                <tr>
                                    <th class="thead_custom_left thead_custom_top pa-3">
                                        타이틀
                                    </th>
                                    <th class="thead_custom_right thead_custom_top pa-3">
                                        <span><Input placeholder="name" :value="name" viewType="name" @input="handleInput"/></span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        그룹
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <AppSelect :datas="datas" :items="items" @item-selected="selGrouping" style="height: 40px;"></AppSelect>
                                        <!-- <span>{{ assetInfo.groups?.toString() }}</span> -->
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        기재
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span><Input placeholder="기재" :value="explanation" viewType="explanation" @input="handleInput"/></span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        퍼블리싱
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <!-- <span>{{ switchState }}</span> -->
                                        <CustomSwitch :switchState="switchState" :toggleSwitch="toggleSwitch"/>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        태그
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span><Input :value="tagVal" placeholder="tag" viewType="tag" :handleEnter="handleEnter"/></span>
                                        <!-- <v-chip v-for="(chip, index) in chips" :key="index" close @click:close="removeChip(index)">
                                            {{ chip }}
                                        </v-chip> -->
                                        <AssetTag
                                            v-for="(chip, index) in chips"
                                            :name="chip"
                                            :onClose="() => onClose(chip)"
                                            :key="'chip_' + index"
                                            :chipsColor="'#edf5ff'"
                                            class="mt-2 mr-1"
                                            style="color: #006cea;"
                                        ></AssetTag>
                                        <AssetTag
                                            v-for="(tag, index) in tags"
                                            :name="tag.tag_name"
                                            :onClose="() => onClose(tag)"
                                            :key="'tag_' + index"
                                            :chipsColor="'#edf5ff'"
                                            class="mt-2 mr-1"
                                            style="color: #006cea;"
                                        ></AssetTag>
                                    </th>
                                </tr>

                            </thead>
                        </template>
                    </v-simple-table>

                    <div style="display: flex;justify-content: space-between">
                        <div>
                            <!-- <TextButton buttonText="목록" class="mt-2 mr-2" iconColor="#ccc" icon="mdi-menu" :buttonClick="() => goAsset()"/> -->
                            <TextButton buttonText="목록" class="mt-2 mr-2" iconColor="#ccc" icon="mdi-menu" @click="goAsset()"/>
                        </div>
                        <div class="text-right">
                            <TextButton buttonText="저장" class="mt-2" isPrimary @click="updateInfo()"/>
                        </div>
                        
                    </div>
                </div>
            </v-col>
                
            <v-col class="right_wraper" style="margin-left: 500px;">
                <div class="ml-5">
                    <h3 class="table_title">
                        플레이 리스트
                    </h3>

                    <v-simple-table>
                        <template>
                        <thead>
                            <tr>
                                <th class="thead_custom_left thead_custom_top pa-3" style="height: 124px;">
                                    <v-row>
                                        <v-col cols="8">
                                            <h4>HLS URL</h4>  
                                        </v-col>
                                        <v-col cols="4">
                                            <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                            @click="copyBtn(smil_url)" />
                                        </v-col>
                                    </v-row>
                                </th>
                                <th class="thead_custom_right thead_custom_top pa-3">
                                    <span class="text_box" >{{ smil_url }}</span>
                                </th>
                            </tr>
                            <tr>
                                <th class="thead_custom_left pa-3" style="height: 124px;">
                                    <v-row>
                                        <v-col cols="8">
                                            <h4>Embedded Player URL</h4>  
                                        </v-col>
                                        <v-col cols="4" style="align-items: center;display: flex;">
                                            <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                            @click="copyBtn(smil_player_url)" />
                                        </v-col>
                                    </v-row>
                                </th>
                                <th class="thead_custom_right pa-3">
                                    <span class="text_box">{{ smil_player_url }}</span>
                                </th>
                            </tr>
                        </thead>
                    </template>
                </v-simple-table>

                </div>

                <div class="ml-5 mt-5">
                    <h3 class="table_title">
                        <!-- 영상 상세 정보 -->
                         인코딩 정보
                    </h3>

                    <v-simple-table>
                        <template>
                            <thead>

                                <!-- <tr>
                                    <th class="thead_custom_left thead_custom_top pa-3">
                                        시간
                                    </th>
                                    <th class="thead_custom_right thead_custom_top pa-3">
                                        <span>{{  assetInfo.runtime }}</span>.000
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        사이즈
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span>{{ size }}</span>
                                    </th>
                                </tr> -->
                                <tr>
                                    <th class="thead_custom_left thead_custom_top pa-3">
                                        인코딩 정보
                                    </th>
                                    <th class="thead_custom_right thead_custom_top pa-3">
                                        <span class="mr-2">원본</span>
                                        <TextButton class="mr-5" buttonText="보기" :xsmall="true" @click="showOriginInfo()"/>
                                    <template v-for="(item, index) in encodeList">
                                        <span :key="index" class="mr-5">
                                            <span class="mr-2">{{ item }}</span>
                                            <TextButton buttonText="보기" :xsmall="true" @click="showInfo(item, index)"/>
                                        </span>
                                    </template>
                                </th>
                                </tr>

                            </thead>
                        </template>
                    </v-simple-table>
                </div>

                <div class="ml-5 mt-8">
                    <h3 class="table_title">
                        파일 메타데이터 
                    </h3>
                    <v-simple-table>
                        <template>
                            <thead>
                                <tr>
                                    <th class="thead_custom_left thead_custom_top pa-3">
                                        시간
                                    </th>
                                    <th class="thead_custom_right thead_custom_top pa-3">
                                        <span>{{  assetInfo.runtime }}</span>.000
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 54px;">
                                        해상도
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span>{{ metaInfo.resolution }}</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 54px;">
                                        코덱 이름
                                    </th>
                                    <th class="thead_custom_right pa-3" style="height: 54px;">
                                        <span>{{ metaInfo.codec }}</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 54px;">
                                        전송률
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span>{{ metaInfo.bitrate }}</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 54px;">
                                        사이즈
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span>{{ metaInfo.size }}</span>
                                    </th>
                                </tr>


                            </thead>
                        </template>
                    </v-simple-table>
                </div>
            </v-col>
        </v-row>

            <!-- 삭제 확인 modal -->
            <AppDialog :value="delConfirm" :persistent="true" @input="delConfirm = $event">
                    <template v-slot:title>
                        <span>썸네일 삭제</span>
                    </template>
                
                    <!-- <template v-slot:close>
                        <div style="float: right;">
                            <v-icon small @click="closeDialog('delConfirm')">mdi-close</v-icon>
                        </div>
                    </template> -->
                
                
                <template v-slot:content>
                <span>선택한 썸네일 이미지 파일을 삭제하시겠습니까?</span>
                </template>
                <template v-slot:actions>
                    <!-- <v-btn @click="deleteThumbnail(selIdx)">삭제</v-btn> -->
                    <TextButtonBlock buttonText="취소" @click="closeDialog('delConfirm')" />
                    <TextButtonBlock buttonText="삭제" @click="deleteThumbnail(selIdx)" isPrimary />
                </template>
            </AppDialog>

            <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

    </div>
</template>

<style>
.cont_title {margin-top: 20px;padding-bottom: 10px;border-bottom: 1px solid #000;font-size: 18px;}
.thumnail_box {margin-top: 10px;}
.thumnail_upload {width: 100%; height: 48px;border: 1px dotted #bbb;text-align: center;font-size: 10px;color: #bbb;}
.thumnail_upload span {color: #bbb;}
.table_title {font-size: 18px;padding-bottom: 10px;}
.modify_left_wraper {width: 500px !important;}
.right_wraper {width: 100%;}
.text_box {word-break:break-all;}
.table_text {background: #fff;}

@media only screen and (max-width: 780px) {
    
}
</style>